import * as React from "react"
import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "./Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import Modal from "./Model"
import { useState } from "react"
import { CrudProvider, useCrudContext } from "@/context/crudContext"

export default function StockAdjustmentList() {
  return (
    <>
      <div className="breadcrumb-card">
        <h5>Stock Adjustment</h5>
      </div>

      <CrudProvider>
        <StockAdjustmentTable />
      </CrudProvider>
    </>
  )
}

function StockAdjustmentTable() {
  const { openDialog } = useCrudContext()

  return (
    <>
      <CustomTable
        label="Stock Adjustment"
        columns={columns}
        apiPath="stock-adjustments"
      />

      {openDialog ? <Modal /> : null}
    </>
  )
}
